import React from 'react'

import { ENABLE_F2F_BOOKINGS } from '~/constants'
import { useAppointmentInvitesQuery } from '~/generated'

import TimelineConsultationActionsView from './TimelineConsultationActionsView'

interface TimelineConsultationActionsProps {
  consultationId: string
  isIncomplete: boolean
}

const TimelineConsultationActions = ({
  consultationId,
  isIncomplete,
}: TimelineConsultationActionsProps) => {
  const { data, loading, error } = useAppointmentInvitesQuery({
    variables: { id: consultationId, f2fOn: ENABLE_F2F_BOOKINGS },
  })
  const appointmentInvites = data?.consultation?.appointmentInvites ?? []

  return (
    <TimelineConsultationActionsView
      appointmentInvites={appointmentInvites}
      isIncomplete={isIncomplete}
      loading={loading}
      error={error}
    />
  )
}

export default TimelineConsultationActions
